import {deprecate} from 'util';

export class GroupSearch {
  company_id: number;
  influencerGroup_id: string;
  selectedCountry: number;
  selectedPlatform: number;
  selectedGender: number;
  // activity filter
  reachFrom: number;
  reachTo: number;
  engagementFrom: number;
  engagementTo: number;
  impactFrom: number;
  impactTo: number;
  followerFrom: number;
  followerTo: number;

  pageNo: number | 1;
  pageSize: number;
  searchString: string;

  limit: number;
  offset: number;
  orderBy: string;
  isAscendingOrder: number | 0;
  scrollId: string;
}

export class ActivitySearchCriteria {
  selectedReach: FilterRange;
  selectedFollower: FilterRange;
  selectedEngagement: FilterRange;
  selectedImpact: FilterRange;
}


export class FilterRange {
  from: number;
  to: number;
  constructor(from: number, to: number) {
    this.from = from;
    this.to = to;
  }
}



// WEBPACK FOOTER //
// ./src/models/group-search.ts